module.exports = __webpack_public_path__ + "img/e.637acc60.png";